import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { activityApi } from '../api/activity.api';
import { useAuth } from '../context/AuthContext';

export function useActivityTracker() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    // Only track if authenticated and path changed
    if (isAuthenticated && location.pathname !== lastTrackedPath.current) {
      lastTrackedPath.current = location.pathname;

      // Don't track login page
      if (location.pathname === '/login') return;

      // Track page visit (fire and forget)
      activityApi.trackPageVisit(location.pathname).catch(() => {
        // Silently fail - tracking shouldn't break the app
      });
    }
  }, [location.pathname, isAuthenticated]);
}
